import { ReactComponent as GhostIconSVG } from '../assets/images/ghost-icon.svg';

const GhostMessage = ({ customMessage = 'Nothing here, yet!', children }: { customMessage?: string; children?: React.ReactNode }) => {
  return (<>
    <div className="grow flex flex-col items-center justify-center">
      <GhostIconSVG />
        <div className="mt-4 font-sora font-semibold text-lg leading-[140%] text-light-grey">
          {customMessage}
        </div>
        {children}
    </div>
  </>);
};

export default GhostMessage;
